export default __webpack_public_path__ + "static/media/special_offer.35c91076.png";